import ResultHeader from './ResultHeader'
import { useEffect, useState } from 'react'
import { Text, useWindowSize } from '../../../../modules/Dashboard'
import Charts from '../../charts/Charts'
import { useResultData } from '../../hooks/useResultData'
import { usePredictContext } from '../../context/PredictContextProvider'
import { useSearchParams } from 'react-router-dom'
import RenderAnalyze from '../Parsers'
import AILoading from '../loading'
import ScenariosTab from '../ScenariosTab'
import { ScaleLoader } from 'react-spinners'
import ModalLayout from '../../../../components/layouts/ModalLayout'
import NoPlanModal from '../modals/NoPlanModal'
import { MOBILE_SIZE } from '../../../../core/constants/common'
import MobileModal from '../../../../components/layouts/MobileModal'

const ResultMain = () => {
    const { width } = useWindowSize()
    const { responseType, assistant, step, ticker, predictHistory, reset: resetPredictCtx } = usePredictContext()
    const { data, loading, error } = useResultData()
    const [, setSearchParams] = useSearchParams()

    const [openNoPlanModal, setOpenNoPlanModal] = useState(false)
    const closeNoPlanModal = () => {
        setOpenNoPlanModal(false)
        resetPredictCtx()
    }

    useEffect(() => {
        if (!assistant.assistant || !responseType || !ticker) {
            step.setCurrentStep("entry")
            setSearchParams({ step: "entry" })
        }
        return () => {
            resetPredictCtx()
        }
    }, [])

    useEffect(() => {
        if (error?.response?.status === 406) {
            setOpenNoPlanModal(true)
        }
    }, [error])


    if (!error && loading) {
        if (predictHistory.predictHistoryId) {
            return (
                <div className='max-w-screen-xl h-[calc(100vh-10rem)] flex items-center justify-center mx-auto backdrop-blur-2xl z-[999]'>
                    <ScaleLoader color='#9F64DF' />
                </div>
            )
        } else return <AILoading loading={loading} />
    }

    if (error && error?.response?.status === 406) {
        return (
            <>
                {width >= MOBILE_SIZE ?

                    <ModalLayout width={"550px"} open={openNoPlanModal} onClose={closeNoPlanModal}>
                        <NoPlanModal onClose={closeNoPlanModal} />
                    </ModalLayout> :
                    <MobileModal noPadding isOpen={openNoPlanModal} onClose={closeNoPlanModal}>
                        <NoPlanModal onClose={closeNoPlanModal} />
                    </MobileModal>
                }
            </>
        )
    }


    return (
        <>
            <div className=' mx-auto'>

                <div className='grid grid-cols-1 gap-6'>
                    <ResultHeader date={data?.createdAt} coin={data?.ticker} />
                    {/* <div className='md:min-h-[370px] lg:min-h-[570px]'>
                            <Charts />
                        </div> */}
                    <ScenariosTab advance={data?.advance} />
                    <RenderAnalyze markdown={data?.reasoning} advance={data?.advance} />
                </div>

            </div>
        </>
    )
}

export default ResultMain



